module.exports = __webpack_public_path__ + "static/media/stop-long-icon.bba9d103.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peterpan/stop-long-icon.svg
// module id = 814
// module chunks = 0